
import './App.css';
import { Routes, Route } from "react-router-dom";
import Home from './pages/Home';
import About from './pages/About';
import Treatments from './pages/Treatments';
import Contact from './pages/Contact';
import PostNatal from './components/Treatments/PostNatalCare';
import Rejuvenation from './components/Treatments/Rejuvenation';
import Hair from './components/Treatments/HairTreatment';
import LifeCycle from './components/Treatments/LifeCycle';
import Soundarya from './components/Treatments/Soundarya';
import "bootstrap-icons/font/bootstrap-icons.css";
import Terms_condition from './components/Terms_condition';

function App() {
  return (
    <div>
       <>
        <Routes>
        <Route path="/" element={<Home/>} />
        <Route path="/ourstory" element={<About/>} />
        <Route path="/treatment" element={<Treatments />}/> 
        <Route path="/postNatal" element={<PostNatal/>}/>
        <Route path="/rejuvenation" element={<Rejuvenation/>}/>
        <Route path="/hair_treatment" element={<Hair/>}/>
        <Route path="/lifestyle_yoga" element={<LifeCycle/>}/>
        <Route path="/soundarya_kalpa" element={<Soundarya/>}/>
        <Route path="/contact" element={<Contact />}/>
        <Route path="/terms_condition" element={<Terms_condition/>}/>
      
        </Routes>
        </>
     </div>
 
  );
}

export default App;
